import { render, staticRenderFns } from "./MidPicNews.vue?vue&type=template&id=29520d33&scoped=true"
import script from "./MidPicNews.vue?vue&type=script&lang=js"
export * from "./MidPicNews.vue?vue&type=script&lang=js"
import style0 from "./MidPicNews.vue?vue&type=style&index=0&id=29520d33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29520d33",
  null
  
)

export default component.exports